const STORAGE_PREFIX = 'sw:awaitWelcome:';
const EXPECT_TTL_MS = 10 * 60 * 1000;

const storageKey = transactionId => {
  const id = transactionId?.uuid || transactionId;
  return id ? `${STORAGE_PREFIX}${id}` : null;
};

/** Mark that Order Details should wait/poll for a post-booking welcome message. */
export const markExpectWelcomeMessage = transactionId => {
  const key = storageKey(transactionId);
  if (!key || typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.setItem(key, String(Date.now()));
  } catch (e) {
    // Ignore quota / private mode failures.
  }
};

export const clearExpectWelcomeMessage = transactionId => {
  const key = storageKey(transactionId);
  if (!key || typeof sessionStorage === 'undefined') {
    return;
  }
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    // Ignore.
  }
};

/**
 * True if checkout recently marked this tx as expecting a welcome message.
 * Does not remove the flag — clear after the message appears or polling times out.
 */
export const peekExpectWelcomeMessage = transactionId => {
  const key = storageKey(transactionId);
  if (!key || typeof sessionStorage === 'undefined') {
    return false;
  }
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) {
      return false;
    }
    const stamped = Number(raw);
    if (!Number.isFinite(stamped) || Date.now() - stamped > EXPECT_TTL_MS) {
      sessionStorage.removeItem(key);
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Typing/poll only when a welcome send is actually in flight or already queued.
 * A skipped send (listing has no automated message) must not show the animation.
 */
export const shouldAwaitWelcomeMessage = ({
  welcomeAlreadySent = false,
  welcomePending = false,
  triggerResult = null,
} = {}) =>
  !!(
    welcomeAlreadySent ||
    welcomePending ||
    triggerResult === 'sent' ||
    triggerResult === 'pending'
  );
